import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'

type Props = {
    open: boolean
    title: React.ReactNode
    children: React.ReactNode
    onClose?: () => void
    onExited?: () => void
}

export function LogisticsProviderDialog({ open, title, children, onExited, onClose }: Props) {
    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            TransitionProps={{ onExited }}
            onClose={onClose}
        >
            <DialogTitle>{title}</DialogTitle>

            <DialogContent>
                <Typography gutterBottom variant="subtitle2">
                    {gettext('Logistics providers')}
                </Typography>

                {children}
            </DialogContent>
            <DialogActions>
                <Button color="secondary" onClick={onClose}>
                    {gettext('Close')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
